// extracted by mini-css-extract-plugin
export default {"menu":"DropdownMenu_menu__OW35q","searchWrapper":"DropdownMenu_searchWrapper__38ePJ","menuItem":"DropdownMenu_menuItem__cPb+L"};